module.exports = __webpack_public_path__ + "img/AF.17b46da6.jpg";